import {PartialGameViewModel} from "../../../domain/partial-game/models/partial-game-view-model";
import {RecentMatchBadgeImageRequestParams} from "../../../core/components/game-badge/recent-match-badge.image-request-params";

export class StandingsWidgetRecentFormGameViewModel extends PartialGameViewModel {
  get title(): String {
    const homeCompetitorName: String = this.homeCompetitor.name;
    const awayCompetitorName: String = this.awayCompetitor.name;

    const homeCompetitorScore: String = this.homeCompetitor.score;
    const awayCompetitorScore: String = this.awayCompetitor.score;

    return `${homeCompetitorName} ${homeCompetitorScore} - ${awayCompetitorScore} ${awayCompetitorName}\n${this.date}`
  }

  get badgeLogoType(): RecentMatchBadgeImageRequestParams {
    return new RecentMatchBadgeImageRequestParams(this.outcome,24,24)
  }
}
